export const assigneeType = (data: any) => {
  if (data === "2") {
    return "Management";
  }
  if (data === "3") {
    return "Employee";
  } else void 0;
};
